// Core imports
import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// Component imports
import { Button, notification } from 'antd';
import PublicRoute from './Routes/PublicRoute';
import MainLayout from '../components/Layout/MainLayout';
import PageNotFoundScreen from './PageNotFoundScreen';
import HomeScreen from './HomeScreen';
import NdeCreateScreen from './NdeCreateScreen';
import NdeEditScreen from './NdeEditScreen';
import NdesScreen from './NdesScreen';
import NdeScreen from './NdeScreen';
import PrivacyPolicyScreen from './PrivacyPolicyScreen';
import FaqScreen from '../components/NDEs/FaqScreen';
import LegalNoticeScreen from '../screens/LegalNoticeScreen';
import AboutScreen from './AboutScreen';
import JoinUsScreen from './JoinUsScreen';
import StatisticsScreen from './StatisticsScreen';
import DonateScreen from './DonateScreen';
import BlogScreen from './BlogScreen';
import BlogPostScreen from './BlogPostScreen';
import BlogAuthorScreen from './BlogAuthorScreen';
import BlogLoginScreen from './BlogLoginScreen';
import BlogEditorScreen from './BlogEditorScreen';

// Misc imports
import {
  NAV_FAQ, NAV_HOME, NAV_JOIN_US, NAV_DONATE, NAV_LEGAL_NOTICE,
  NAV_NDES, NAV_NDES_CREATE, NAV_NDES_EDIT, NAV_NDES_VIEW,
  NAV_ABOUT, NAV_PRIVACY_POLICY, NAV_STATISTICS,
  NAV_BLOG, NAV_BLOG_POST, NAV_BLOG_AUTHOR, NAV_BLOG_LOGIN,
  NAV_BLOG_EDITOR_NEW, NAV_BLOG_EDITOR_EDIT
} from '../constants';
import { acceptCookiePolicy } from '../store/global/globalThunks';

const ScreensRoot = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const { hasAcceptedCookiePolicy } = useSelector((state) => state.global);

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // On mount
  useEffect(() => {
    if (!hasAcceptedCookiePolicy) {
      notification.open({
        key: 'cookies',
        message: 'Cookie Policy',
        description: 'This website only uses essential cookies to enhance your experience. There are no cookies containing behavior or user information.',
        placement: 'bottomLeft',
        duration: 0,
        btn: (
          <Button
            type="primary"
            size="small"
            onClick={() => {
              notification.close('cookies');
              dispatch(acceptCookiePolicy());
            }}
          >
            I understand
          </Button>
        )
      });
    }
  }, []);

  return (
    <Routes>
      <Route
        path={NAV_HOME}
        exact
        element={<PublicRoute layout={MainLayout} component={HomeScreen} />}
      />

      <Route
        path={`${NAV_NDES_CREATE}/*`}
        exact={false}
        element={<PublicRoute layout={MainLayout} component={NdeCreateScreen} />}
      />

      <Route
        path={`${NAV_NDES_EDIT}/*`}
        exact={false}
        element={<PublicRoute layout={MainLayout} component={NdeEditScreen} />}
      />

      <Route
        path={`${NAV_NDES_VIEW}/*`}
        exact={false}
        element={<PublicRoute layout={MainLayout} component={NdeScreen} />}
      />

      <Route
        path={NAV_NDES}
        exact
        element={<PublicRoute layout={MainLayout} component={NdesScreen} />}
      />

      <Route
        path={NAV_PRIVACY_POLICY}
        exact
        element={<PublicRoute layout={MainLayout} component={PrivacyPolicyScreen} />}
      />

      <Route
        path={NAV_FAQ}
        exact
        element={<PublicRoute layout={MainLayout} component={FaqScreen} />}
      />

      <Route
        path={NAV_LEGAL_NOTICE}
        exact
        element={<PublicRoute layout={MainLayout} component={LegalNoticeScreen} />}
      />

      <Route
        path={NAV_ABOUT}
        exact
        element={<PublicRoute layout={MainLayout} component={AboutScreen} />}
      />

      <Route
        path={NAV_STATISTICS}
        exact
        element={<PublicRoute layout={MainLayout} component={StatisticsScreen} />}
      />

      <Route
        path={NAV_JOIN_US}
        exact
        element={<PublicRoute layout={MainLayout} component={JoinUsScreen} />}
      />

      <Route
        path={NAV_DONATE}
        exact
        element={<PublicRoute layout={MainLayout} component={DonateScreen} />}
      />

      <Route
        path={NAV_BLOG}
        exact
        element={<PublicRoute layout={MainLayout} component={BlogScreen} />}
      />

      <Route
        path={NAV_BLOG_LOGIN}
        exact
        element={<PublicRoute layout={MainLayout} component={BlogLoginScreen} />}
      />

      <Route
        path={NAV_BLOG_EDITOR_NEW}
        exact
        element={<PublicRoute layout={MainLayout} component={BlogEditorScreen} />}
      />

      <Route
        path={NAV_BLOG_EDITOR_EDIT}
        exact
        element={<PublicRoute layout={MainLayout} component={BlogEditorScreen} />}
      />

      <Route
        path={NAV_BLOG_AUTHOR}
        exact
        element={<PublicRoute layout={MainLayout} component={BlogAuthorScreen} />}
      />

      <Route
        path={NAV_BLOG_POST}
        exact
        element={<PublicRoute layout={MainLayout} component={BlogPostScreen} />}
      />

      <Route
        path="*"
        element={<PublicRoute layout={MainLayout} component={PageNotFoundScreen} />}
      />
    </Routes>
  );
};

export default ScreensRoot;
